import {kngApi} from 'yxt-biz-pc/packages/api';
// 获取课程类型

export const getCommentInfo = data => kngApi.post('/comment/info', data);
